import { render, staticRenderFns } from "./hot-news.vue?vue&type=template&id=7e5f6ceb&scoped=true&"
import script from "./hot-news.vue?vue&type=script&lang=js&"
export * from "./hot-news.vue?vue&type=script&lang=js&"
import style0 from "./hot-news.vue?vue&type=style&index=0&id=7e5f6ceb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5f6ceb",
  null
  
)

export default component.exports